<script>
    import {getStyleValue, imageUrl} from "../../Common/tools"
    import TextEditor from "../../Common/TextEditor.svelte";
    import {External} from "../../external";

    export let data, meta, globalStyle, onChange;

    function change(side, val) {
      onChange();
      data[side] = Object.assign({}, data[side], {content: val});
    }

    const placeholder = External.resources + '/images/marketing/placeholders/100x100.png';

</script>
<tr>
    <td>
        <table>
            <tr style="vertical-align: top;" valign="top">
                <th class="column mobile-12"
                    style="padding-left: 30px; padding-right: 10px; max-width: {getStyleValue(globalStyle.width, 600)*0.5}px"
                    width="{getStyleValue(globalStyle.width, 600)*0.5}">
                    <table class="row" cellspacing="0" cellpadding="0" bgcolor="{data.style.color}" align="center">
                        <tbody>
                        <tr>
                            <th class="column" style="font-weight: 400; text-align: left;" width="100%">
                                <div style="margin-left: 20px; margin-top: 20px;">
                                    <img src="{imageUrl(data.left, placeholder)}" alt=""
                                         style="border: 0; border-radius: 50%; width: 100%; width: 50px; height: 50px;"
                                         width="50">
                                </div>
                                <div style="margin: 30px">
                                    <TextEditor meta={meta} data={data.left.content}
                                                onChange={(val) => change('left', val)} emailEditor={true} />
                                </div>
                            </th>
                        </tr>
                        </tbody>
                    </table>
                </th>
                <th class="column mobile-12 mobile-padding-top"
                    style="padding-left: 10px; padding-right: 30px; max-width: {getStyleValue(globalStyle.width, 600)*0.5}px"
                    width="{getStyleValue(globalStyle.width, 600)*0.5}">
                    <table class="row" cellspacing="0" cellpadding="0" bgcolor="{data.style.color}" align="center">
                        <tbody>
                        <tr>
                            <th class="column" style="font-weight: 400; text-align: left;" width="100%">
                                <div style="margin-left: 20px; margin-top: 20px;">
                                    <img src="{imageUrl(data.right, placeholder)}" alt=""
                                         style="border: 0; border-radius: 50%; width: 100%; width: 50px; height: 50px;"
                                         width="50">
                                </div>
                                <div style="margin: 30px">
                                    <TextEditor meta={meta} data={data.right.content}
                                                onChange={(val) => change('right', val)} emailEditor={true} />
                                </div>
                            </th>
                        </tr>
                        </tbody>
                    </table>
                </th>
            </tr>
        </table>
    </td>
</tr>
